//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

// So far this list just includes sorts supported in:
// - streams drawer,
// - fanreel moderation view
// - and media library
// - instagram hashtag page
enum SUPPORTED_SORT_ORDER {
  POSTED_TIMESTAMP = 'postedtimestamp',
  DATE = 'date',
  TIME = 'time',
  MOD_DATE = 'moddate',
  COMMENTS = 'comments',
  LIKES = 'likes',
  ENGAGEMENT = 'engagement',
  FOLLOWERS = 'followers',
  VISUAL_SCORE = 'visualscore',
  EMV = 'emv',
}

enum GA_SORT_LABEL {
  MOST_RECENTLY_POSTED = 'mostRecentlyPosted',
  MOST_RECENTLY_MODERATED = 'mostRecentlyModerated',
  MOST_COMMENTS = 'mostComments',
  MOST_LIKES = 'mostLikes',
  MOST_ENGAGING = 'mostEngaging',
  MOST_FOLLOWERS = 'mostFollowers',
  MOST_ON_BRAND = 'mostOnBrand',
  HIGHEST_EMV = 'highestEmv',
}

// Different sorting dropdowns in the dashboard use different values for the same sort order.
// This function consolidates values that are differently named but functionally the same
// into unique labels for use in GA events
export function getSortLabel(sortOrder: SUPPORTED_SORT_ORDER): GA_SORT_LABEL | null {
  switch (sortOrder.toLowerCase()) {
    case SUPPORTED_SORT_ORDER.POSTED_TIMESTAMP:
    case SUPPORTED_SORT_ORDER.DATE:
    case SUPPORTED_SORT_ORDER.TIME:
      return GA_SORT_LABEL.MOST_RECENTLY_POSTED;

    case SUPPORTED_SORT_ORDER.MOD_DATE:
      return GA_SORT_LABEL.MOST_RECENTLY_MODERATED;

    case SUPPORTED_SORT_ORDER.COMMENTS:
      return GA_SORT_LABEL.MOST_COMMENTS;

    case SUPPORTED_SORT_ORDER.LIKES:
      return GA_SORT_LABEL.MOST_LIKES;

    case SUPPORTED_SORT_ORDER.ENGAGEMENT:
      return GA_SORT_LABEL.MOST_ENGAGING;

    case SUPPORTED_SORT_ORDER.FOLLOWERS:
      return GA_SORT_LABEL.MOST_FOLLOWERS;

    case SUPPORTED_SORT_ORDER.VISUAL_SCORE:
      return GA_SORT_LABEL.MOST_ON_BRAND;

    default:
      return null;
  }
}
